export enum PublishRulesDeadlineModesEnum {
  IMMEDIATELY = 'IMMEDIATELY',
  TOMORROW = 'TOMORROW',
  DAY_OF_MONTH = 'DAY_OF_MONTH',
}
